import { render, staticRenderFns } from "./TagsNavigator.vue?vue&type=template&id=0d8d8da0&scoped=true&"
import script from "./TagsNavigator.vue?vue&type=script&lang=js&"
export * from "./TagsNavigator.vue?vue&type=script&lang=js&"
import style0 from "./TagsNavigator.vue?vue&type=style&index=0&id=0d8d8da0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8d8da0",
  null
  
)

export default component.exports